<template>
    <div>
      <div class="container mx-auto text-center">
        <div class="form-group admin-menu">
          <div class="flex space-x-2 overflow-x-auto pb-2">
            <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-square" @click="addTable()">
              Masa Ekle
            </vs-button>
            <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-circle" @click="setMode('wall')">
              Duvar Ekle
            </vs-button>
            <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-triangle" @click="addKitchen()">
              Mutfak Ekle
            </vs-button>
            <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-triangle" @click="addBar()">
              Bar Ekle
            </vs-button>
            <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteSelectedElement()">
              Sil
            </vs-button>
            <vs-button type="gradient" color="info" icon-pack="feather" icon="icon-save" @click="saveLayout()">
              Kaydet
            </vs-button>
            <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-user" @click="setMode('select')">
                Seçim Modu
            </vs-button>
            <vs-button type="gradient" color="warning" icon-pack="feather" icon="icon-maximize" @click="toggleFullscreen">
            {{ isFullscreen ? 'Küçült' : 'Tam Ekran' }}
          </vs-button>
          </div>
        </div>
        
        <div id="editor-container">
        <svg id="editor" @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp"></svg>
    </div>
    <div :class="['minimap', { 'hidden': !showMinimap }]" id="minimap" @click="handleMinimapClick" @mousedown="startDraggingMinimap" @touchstart="startDraggingMinimap">
      <div id="minimap-viewport"></div>
    </div>    
    <div id="minimap-toggle" @click="toggleMinimap">
      <i :class="['fas', showMinimap ? 'fa-times' : 'fa-map']"></i>
    </div>
      </div>
    </div>
  </template>
<script>
import { getBranchTableMap, saveBranchTableMap } from '@/api/BranchSiteMap';
export default {
    data() {
        return {
            svg : null,
            editorContainer : null,
            minimap : null,
            minimapViewport : null,
            tableCount : 0,
            wallCount : 0,
            kitchenCount : 0,
            mode : 'select',
            selectedElement : null,
            offset : null,
            drawingWall : null,
            startPoint : null,
            selectionArea : null,
            selectedElements : [],
            isSelecting : false,
            selectionStartPoint : null,
            isDraggingMultiple : false,
            isDraggingMinimap : false,
            minimapStartX : null,
            minimapStartY : null,
            barCount : 0,
            showMinimap: true,
            isFullscreen: false,
        }
    },
    mounted() {
        this.svg = document.getElementById('editor');
        this.editorContainer = document.getElementById('editor-container');
        this.minimap = document.getElementById('minimap');
        this.minimapViewport = document.getElementById('minimap-viewport');

        document.addEventListener('mousemove', this.dragMinimap);
        document.addEventListener('touchmove', this.dragMinimap, { passive: false });
        document.addEventListener('mouseup', this.stopDraggingMinimap);
        document.addEventListener('touchend', this.stopDraggingMinimap);
        this.editorContainer.addEventListener('scroll', this.updateMinimap);
        window.addEventListener('resize', this.updateMinimap);

        document.addEventListener('keydown', this.handleKeyDown);
        this.loadLayout();
        this.$nextTick(() => {
            this.updateMinimap();
            this.setSVGDimensions();
        });
        document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
    },
    beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
    },
    methods : {
        setSVGDimensions() {
            const containerHeight = window.innerHeight;
            const containerWidth = window.innerWidth;
            this.svg.style.width = '2000px';
            this.svg.style.height = '2000px';
            this.editorContainer.style.height = `${containerHeight}px`;
            this.editorContainer.style.width = `${containerWidth}px`;
        },
        handleKeyDown(evt) {
            if (evt.key === 'Escape') {
                this.deselectAll();
            } else if (this.selectedElement || this.selectedElements.length > 0) {
                evt.preventDefault();
                switch (evt.key) {
                    case 'ArrowLeft':
                        this.moveSelectedElements(-5, 0);
                        break;
                    case 'ArrowRight':
                        this.moveSelectedElements(5, 0);
                        break;
                    case 'ArrowUp':
                        this.moveSelectedElements(0, -5);
                        break;
                    case 'ArrowDown':
                        this.moveSelectedElements(0, 5);
                        break;
                    case 'Enter':
                        this.rotateSelectedElement();
                        break;
                    case 'Delete':
                        this.deleteSelectedElements();
                        break;
                }
            }
        },
        handleMouseDown(evt) {
            if (this.mode === 'wall') {
                this.startDrawingWall(evt);
            } else if (this.mode === 'select') {
                this.startSelectionArea(evt);
            }
        },
        handleMouseMove(evt) {
            if (this.mode === 'wall') {
                this.continueDrawingWall(evt);
            } else if (this.mode === 'select' && this.isSelecting) {
                this.updateSelectionArea(evt);
            }
        },
        handleMouseUp() {
            if (this.mode === 'wall') {
                this.finishDrawingWall();
            } else if (this.mode === 'select') {
                this.finishSelectionArea();
            }
        },
        startDraggingMinimap(evt) {
            this.isDraggingMinimap = true;
            this.minimapStartX = evt.clientX || evt.touches[0].clientX;
            this.minimapStartY = evt.clientY || evt.touches[0].clientY;
        },
        addBar() {
            this.barCount++;
            const bar = document.createElementNS("http://www.w3.org/2000/svg", "g");
            bar.setAttribute('class', 'bar');
            bar.innerHTML = `
                <rect x="0" y="0" width="120" height="40" rx="5" ry="5" fill="#8B4513" />
                <rect x="2" y="2" width="116" height="36" rx="3" ry="3" fill="#D2691E" />
                <rect x="5" y="5" width="110" height="30" fill="#CD853F" />
                <rect x="10" y="10" width="100" height="5" fill="#A0522D" />
                <rect x="10" y="20" width="100" height="5" fill="#A0522D" />
                <circle cx="20" cy="45" r="5" fill="#8B4513" />
                <circle cx="40" cy="45" r="5" fill="#8B4513" />
                <circle cx="60" cy="45" r="5" fill="#8B4513" />
                <circle cx="80" cy="45" r="5" fill="#8B4513" />
                <circle cx="100" cy="45" r="5" fill="#8B4513" />
                <text x="60" y="55" text-anchor="middle" fill="white" font-size="10" font-weight="bold">Bar ${this.barCount}</text>
            `;
            bar.setAttribute('transform', `translate(${this.svg.clientWidth / 2 - 60}, ${this.svg.clientHeight / 2 - 20}) rotate(0)`);
            
            bar.onmousedown = this.startDragging;
            bar.onclick = this.selectElement;

            this.svg.appendChild(bar);
            this.setMode('select');
            this.updateMinimap();
        },
        dragMinimap(evt) {
            if (this.isDraggingMinimap) {
                evt.preventDefault(); // Prevent scrolling on mobile
                const clientX = evt.clientX || evt.touches[0].clientX;
                const clientY = evt.clientY || evt.touches[0].clientY;
                const dx = clientX - this.minimapStartX;
                const dy = clientY - this.minimapStartY;
                
                const editorRect = this.svg.getBoundingClientRect();
                const minimapScale = this.minimap.clientWidth / editorRect.width;
                
                this.editorContainer.scrollLeft += dx / minimapScale;
                this.editorContainer.scrollTop += dy / minimapScale;
                
                this.minimapStartX = clientX;
                this.minimapStartY = clientY;
                
                this.updateMinimap();
            }
        },
        stopDraggingMinimap() {
            this.isDraggingMinimap = false;
        },
        handleMinimapClick(evt) {
            const minimapRect = this.minimap.getBoundingClientRect();
            const editorRect = this.svg.getBoundingClientRect();
            
            // Calculate click position relative to minimap
            const clickX = evt.clientX - minimapRect.left;
            const clickY = evt.clientY - minimapRect.top;
            
            // Calculate the scale between minimap and editor
            const scaleX = editorRect.width / minimapRect.width;
            const scaleY = editorRect.height / minimapRect.height;
            
            // Calculate the new scroll position
            const newScrollLeft = clickX * scaleX - this.editorContainer.clientWidth / 2;
            const newScrollTop = clickY * scaleY - this.editorContainer.clientHeight / 2;
            
            // Set the new scroll position
            this.editorContainer.scrollLeft = newScrollLeft;
            this.editorContainer.scrollTop = newScrollTop;
            
            // Update the minimap viewport
            this.updateMinimap();
        },
        initializeMinimap() {
      this.minimap = document.getElementById('minimap');
      this.minimapViewport = document.getElementById('minimap-viewport');
      
      // Clear previous minimap content
      while (this.minimap.firstChild) {
        this.minimap.removeChild(this.minimap.firstChild);
      }

      // Add minimap viewport
      this.minimap.appendChild(this.minimapViewport);

      // Clone and scale down SVG content for minimap
      const svgClone = this.svg.cloneNode(true);
      svgClone.setAttribute('width', this.minimap.clientWidth);
      svgClone.setAttribute('height', this.minimap.clientHeight);
      svgClone.style.transform = `scale(${this.minimap.clientWidth / this.svg.clientWidth})`;
      svgClone.style.transformOrigin = 'top left';
      this.minimap.appendChild(svgClone);

      // Ensure minimap viewport is on top
            this.minimap.appendChild(this.minimapViewport);
        },  
        updateMinimap() {
            if (!this.showMinimap) return;
            const editorRect = this.svg.getBoundingClientRect();
            const containerRect = this.editorContainer.getBoundingClientRect();
            const minimapScale = this.minimap.clientWidth / editorRect.width;

            this.minimapViewport.style.width = (containerRect.width * minimapScale) + 'px';
            this.minimapViewport.style.height = (containerRect.height * minimapScale) + 'px';
            this.minimapViewport.style.left = (this.editorContainer.scrollLeft * minimapScale) + 'px';
            this.minimapViewport.style.top = (this.editorContainer.scrollTop * minimapScale) + 'px';

            // Clear previous minimap content
            while (this.minimap.firstChild) {
                this.minimap.removeChild(this.minimap.firstChild);
            }

            // Add minimap viewport
            this.minimap.appendChild(this.minimapViewport);

            // Clone and scale down SVG content for minimap
            const svgClone = this.svg.cloneNode(true);
            svgClone.setAttribute('width', this.minimap.clientWidth);
            svgClone.setAttribute('height', this.minimap.clientHeight);
            svgClone.style.transform = `scale(${minimapScale})`;
            svgClone.style.transformOrigin = 'top left';
            this.minimap.appendChild(svgClone);

            // Ensure minimap viewport is on top
            this.minimap.appendChild(this.minimapViewport);
        },
        setMode(newMode) {
            this.mode = newMode;
            this.deselectAll();
        },
        generateGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        addTable() {
            this.tableCount++;
            const tableId = this.generateGUID();
            const table = document.createElementNS("http://www.w3.org/2000/svg", "g");
            table.setAttribute('class', 'table');
            table.setAttribute('data-id', tableId);
            table.setAttribute('data-number', this.tableCount);
            table.innerHTML = `
                <!-- Masa -->
                <rect x="0" y="0" width="60" height="40" rx="5" ry="5" fill="#8B4513" />
                <rect x="2" y="2" width="56" height="36" rx="3" ry="3" fill="#D2691E" />
                <rect x="4" y="4" width="52" height="32" rx="2" ry="2" fill="#A0522D" />
                <rect x="6" y="6" width="48" height="28" fill="#CD853F" />
                <line x1="6" y1="20" x2="54" y2="20" stroke="#8B4513" stroke-width="1" />
                <line x1="30" y1="6" x2="30" y2="34" stroke="#8B4513" stroke-width="1" />
                <!-- Koltuklar -->
                <rect x="-10" y="10" width="20" height="20" rx="3" ry="3" fill="#8B4513" /> <!-- Sol koltuk -->
                <rect x="50" y="10" width="20" height="20" rx="3" ry="3" fill="#8B4513" /> <!-- Sağ koltuk -->
                <rect x="20" y="-10" width="20" height="20" rx="3" ry="3" fill="#8B4513" /> <!-- Üst koltuk -->
                <rect x="20" y="30" width="20" height="20" rx="3" ry="3" fill="#8B4513" /> <!-- Alt koltuk -->
                <!-- Gölge ve etiket -->
                <rect x="0" y="37" width="60" height="6" rx="2" ry="2" fill="#8B4513" opacity="0.6" />
                <text x="30" y="20" text-anchor="middle" fill="white" font-size="14" font-weight="bold">Masa ${this.tableCount}</text>
            `;
            table.setAttribute('transform', `translate(${this.svg.clientWidth / 2 - 30}, ${this.svg.clientHeight / 2 - 30}) rotate(0)`);
            
            table.onmousedown = this.startDragging;
            table.onclick = this.selectElement;

            this.svg.appendChild(table);
            this.setMode('select');
            this.updateMinimap();
        },
        addKitchen() {
            this.kitchenCount++;
            const kitchen = document.createElementNS("http://www.w3.org/2000/svg", "g");
            kitchen.setAttribute('class', 'kitchen');
            kitchen.innerHTML = `
                <!-- Mutfak Alanı -->
                <rect x="0" y="0" width="100" height="80" rx="5" ry="5" fill="#E0E0E0" stroke="#808080" stroke-width="2" />
                <rect x="5" y="5" width="90" height="70" rx="3" ry="3" fill="#F0F0F0" stroke="#A9A9A9" stroke-width="1" />
                <!-- Tezgah -->
                <rect x="10" y="15" width="80" height="20" fill="#D3D3D3" stroke="#A9A9A9" stroke-width="1" />
                <!-- Lavabo -->
                <circle cx="25" cy="25" r="8" fill="#C0C0C0" stroke="#A9A9A9" stroke-width="1" />
                <!-- Ocak -->
                <rect x="60" y="20" width="25" height="10" fill="#696969" stroke="#A9A9A9" stroke-width="1" />
                <!-- Etiket -->
                <text x="50" y="75" text-anchor="middle" fill="black" font-size="10" font-weight="bold">Mutfak ${this.kitchenCount}</text>
            `;
            kitchen.setAttribute('transform', `translate(${this.svg.clientWidth / 2 - 50}, ${this.svg.clientHeight / 2 - 40}) rotate(0)`);
            
            kitchen.onmousedown = this.startDragging;
            kitchen.onclick = this.selectElement;

            this.svg.appendChild(kitchen);
            this.setMode('select');
            this.updateMinimap();
        },
        startDrawingWall(evt) {
            const coord = this.getMousePosition(evt);
            this.startPoint = coord;
            this.drawingWall = document.createElementNS("http://www.w3.org/2000/svg", "line");
            this.drawingWall.setAttribute('class', 'wall');
            this.drawingWall.setAttribute('x1', coord.x);
            this.drawingWall.setAttribute('y1', coord.y);
            this.drawingWall.setAttribute('x2', coord.x);
            this.drawingWall.setAttribute('y2', coord.y);
            this.svg.appendChild(this.drawingWall);
        },
        continueDrawingWall(evt) {
            if (this.drawingWall) {
                const coord = this.getMousePosition(evt);
                this.drawingWall.setAttribute('x2', coord.x);
                this.drawingWall.setAttribute('y2', coord.y);
            }
        },
        finishDrawingWall() {
            if (this.drawingWall) {
                this.wallCount++;
                this.drawingWall.onmousedown = this.startDragging;
                this.drawingWall.onclick = this.selectElement;
                
                this.drawingWall = null;
                this.startPoint = null;
                this.setMode('select');
                this.updateMinimap();
            }
        },
        selectElement(evt) {
            if (this.mode === 'select') {
                this.deselectAll();
                this.selectedElement = evt.target.closest('.table, .wall, .kitchen, .bar');
                if (this.selectedElement) {
                    this.selectedElement.classList.add('selected');
                }
            }
        },
        deselectAll() {
            document.querySelectorAll('.selected').forEach(el => el.classList.remove('selected'));
            this.selectedElement = null;
            this.selectedElements = [];
        },
        getMousePosition(evt) {
            const CTM = this.svg.getScreenCTM();
            return {
                x: (evt.clientX - CTM.e) / CTM.a,
                y: (evt.clientY - CTM.f) / CTM.d
            };
        },
        deleteSelectedElement() {
            if (this.selectedElement) {
                this.selectedElement.remove();
                this.selectedElement = null;
                this.updateMinimap();
            }
        },
        startDragging(evt) {
            if (this.mode === 'select') {
                if (this.selectedElements.length > 0) {
                    this.isDraggingMultiple = true;
                    this.offset = this.getMousePosition(evt);
                } else {
                    this.selectedElement = evt.target.closest('.table, .wall, .kitchen, .bar');
                    this.offset = this.getMousePosition(evt);
                    
                    if (this.selectedElement.classList.contains('table') || this.selectedElement.classList.contains('kitchen') || this.selectedElement.classList.contains('bar')) {
                        const transform = this.selectedElement.getAttribute('transform');
                        const translate = transform.match(/translate\(([^)]+)\)/)[1].split(',');
                        this.offset.x -= parseFloat(translate[0]);
                        this.offset.y -= parseFloat(translate[1]);
                    } else if (this.selectedElement.classList.contains('wall')) {
                        this.offset.x -= parseFloat(this.selectedElement.getAttribute('x1'));
                        this.offset.y -= parseFloat(this.selectedElement.getAttribute('y1'));
                    }
                }

                this.svg.addEventListener('mousemove', this.drag);
                this.svg.addEventListener('mouseup', this.endDrag);
            }
        },
        drag(evt) {
            if (this.isDraggingMultiple) {
                const coord = this.getMousePosition(evt);
                const dx = coord.x - this.offset.x;
                const dy = coord.y - this.offset.y;
                this.moveSelectedElements(dx, dy);
                this.offset = coord;
            } else if (this.selectedElement) {
                evt.preventDefault();
                const coord = this.getMousePosition(evt);
                if (this.selectedElement.classList.contains('table') || this.selectedElement.classList.contains('kitchen') || this.selectedElement.classList.contains('bar')) {
                    const newX = Math.max(0, Math.min(coord.x - this.offset.x, this.svg.clientWidth - this.selectedElement.getBBox().width));
                    const newY = Math.max(0, Math.min(coord.y - this.offset.y, this.svg.clientHeight - this.selectedElement.getBBox().height));
                    const currentRotation = this.getCurrentRotation(this.selectedElement);
                    this.selectedElement.setAttribute('transform', `translate(${newX}, ${newY}) rotate(${currentRotation})`);
                } else if (this.selectedElement.classList.contains('wall')) {
                    const dx = coord.x - this.offset.x - parseFloat(this.selectedElement.getAttribute('x1'));
                    const dy = coord.y - this.offset.y - parseFloat(this.selectedElement.getAttribute('y1'));
                    let x1 = parseFloat(this.selectedElement.getAttribute('x1')) + dx;
                    let y1 = parseFloat(this.selectedElement.getAttribute('y1')) + dy;
                    let x2 = parseFloat(this.selectedElement.getAttribute('x2')) + dx;
                    let y2 = parseFloat(this.selectedElement.getAttribute('y2')) + dy;
                    
                    // Constrain wall within SVG boundaries
                    x1 = Math.max(0, Math.min(x1, this.svg.clientWidth));
                    y1 = Math.max(0, Math.min(y1, this.svg.clientHeight));
                    x2 = Math.max(0, Math.min(x2, this.svg.clientWidth));
                    y2 = Math.max(0, Math.min(y2, this.svg.clientHeight));
                    
                    this.selectedElement.setAttribute('x1', x1);
                    this.selectedElement.setAttribute('y1', y1);
                    this.selectedElement.setAttribute('x2', x2);
                    this.selectedElement.setAttribute('y2', y2);
                }
            }
            this.updateMinimap();
        },
        endDrag() {
            this.svg.removeEventListener('mousemove', this.drag);
            this.svg.removeEventListener('mouseup', this.endDrag);
            this.isDraggingMultiple = false;
            this.selectedElement = null;
            this.updateMinimap();
        },
        startSelectionArea(evt) {
            if (this.mode === 'select' && !this.selectedElement && this.selectedElements.length === 0) {
                const coord = this.getMousePosition(evt);
                this.selectionStartPoint = coord;
                this.selectionArea = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                this.selectionArea.setAttribute('class', 'selection-area');
                this.selectionArea.setAttribute('x', coord.x);
                this.selectionArea.setAttribute('y', coord.y);
                this.selectionArea.setAttribute('width', 0);
                this.selectionArea.setAttribute('height', 0);
                this.svg.appendChild(this.selectionArea);
                this.isSelecting = true;
            }
        },
        updateSelectionArea(evt) {
            if (this.selectionArea && this.isSelecting) {
                const coord = this.getMousePosition(evt);
                const x = Math.min(this.selectionStartPoint.x, coord.x);
                const y = Math.min(this.selectionStartPoint.y, coord.y);
                const width = Math.abs(coord.x - this.selectionStartPoint.x);
                const height = Math.abs(coord.y - this.selectionStartPoint.y);
                
                this.selectionArea.setAttribute('x', x);
                this.selectionArea.setAttribute('y', y);
                this.selectionArea.setAttribute('width', width);
                this.selectionArea.setAttribute('height', height);
            }
        },
        finishSelectionArea() {
            if (this.selectionArea && this.isSelecting) {
                const x = parseFloat(this.selectionArea.getAttribute('x'));
                const y = parseFloat(this.selectionArea.getAttribute('y'));
                const width = parseFloat(this.selectionArea.getAttribute('width'));
                const height = parseFloat(this.selectionArea.getAttribute('height'));
                
                this.selectedElements = [];
                document.querySelectorAll('.table, .wall, .kitchen, .bar').forEach(el => {
                    let elBox;
                    if (el.classList.contains('wall')) {
                        const x1 = parseFloat(el.getAttribute('x1'));
                        const y1 = parseFloat(el.getAttribute('y1'));
                        const x2 = parseFloat(el.getAttribute('x2'));
                        const y2 = parseFloat(el.getAttribute('y2'));
                        elBox = {
                            x: Math.min(x1, x2),
                            y: Math.min(y1, y2),
                            width: Math.abs(x2 - x1),
                            height: Math.abs(y2 - y1)
                        };
                    } else {
                        const bbox = el.getBBox();
                        const transform = el.getAttribute('transform');
                        const translate = transform.match(/translate\(([^)]+)\)/)[1].split(',');
                        elBox = {
                            x: parseFloat(translate[0]) + bbox.x,
                            y: parseFloat(translate[1]) + bbox.y,
                            width: bbox.width,
                            height: bbox.height
                        };
                    }
                
                    if (elBox.x < x + width && elBox.x + elBox.width > x &&
                        elBox.y < y + height && elBox.y + elBox.height > y) {
                        this.selectedElements.push(el);
                        el.classList.add('selected');
                    }
                });
                
                this.selectionArea.remove();
                this.selectionArea = null;
                this.isSelecting = false;
                this.selectionStartPoint = null;
            }
        },
        moveSelectedElements(dx, dy) {
            const elements = this.selectedElements.length > 0 ? this.selectedElements : [this.selectedElement];
            elements.forEach(el => {
                if (el.classList.contains('table') || el.classList.contains('kitchen') || el.classList.contains('bar')) {
                    const transform = el.getAttribute('transform');
                    const translate = transform.match(/translate\(([^)]+)\)/)[1].split(',');
                    const rotate = transform.match(/rotate\(([^)]+)\)/);
                    const newX = Math.max(0, Math.min(parseFloat(translate[0]) + dx, this.svg.clientWidth - el.getBBox().width));
                    const newY = Math.max(0, Math.min(parseFloat(translate[1]) + dy, this.svg.clientHeight - el.getBBox().height));
                    el.setAttribute('transform', `translate(${newX}, ${newY}) rotate(${rotate ? rotate[1] : 0})`);
                } else if (el.classList.contains('wall')) {
                    let x1 = parseFloat(el.getAttribute('x1')) + dx;
                    let y1 = parseFloat(el.getAttribute('y1')) + dy;
                    let x2 = parseFloat(el.getAttribute('x2')) + dx;
                    let y2 = parseFloat(el.getAttribute('y2')) + dy;
                    
                    x1 = Math.max(0, Math.min(x1, this.svg.clientWidth));
                    y1 = Math.max(0, Math.min(y1, this.svg.clientHeight));
                    x2 = Math.max(0, Math.min(x2, this.svg.clientWidth));
                    y2 = Math.max(0, Math.min(y2, this.svg.clientHeight));
                    
                    el.setAttribute('x1', x1);
                    el.setAttribute('y1', y1);
                    el.setAttribute('x2', x2);
                    el.setAttribute('y2', y2);
                }
            });
            this.updateMinimap();
        },
        rotateSelectedElement() {
            if (this.selectedElement && (this.selectedElement.classList.contains('table') || this.selectedElement.classList.contains('kitchen') || this.selectedElement.classList.contains('bar'))) {
                const transform = this.selectedElement.getAttribute('transform');
                const translate = transform.match(/translate\(([^)]+)\)/)[1];
                const currentRotation = this.getCurrentRotation(this.selectedElement);
                const newRotation = (currentRotation + 90) % 360;
                this.selectedElement.setAttribute('transform', `translate(${translate}) rotate(${newRotation})`);
                this.updateMinimap();
            }
        },
        getCurrentRotation(element) {
            const transform = element.getAttribute('transform');
            const rotate = transform.match(/rotate\(([^)]+)\)/);
            return rotate ? parseFloat(rotate[1]) : 0;
        },
        deleteSelectedElements() {
            const elements = this.selectedElements.length > 0 ? this.selectedElements : [this.selectedElement];
            elements.forEach(el => {
                if (el) {
                    el.remove();
                }
            });
            this.selectedElement = null;
            this.selectedElements = [];
            this.updateMinimap();
        },
        moveSelectedElements(dx, dy) {
            const elementsToMove = this.selectedElements.length > 0 ? this.selectedElements : (this.selectedElement ? [this.selectedElement] : []);
            
            elementsToMove.forEach(el => {
                if (el.classList.contains('table') || el.classList.contains('kitchen') || el.classList.contains('bar')) {
                    this.moveTableLikeElement(el, dx, dy);
                } else if (el.classList.contains('wall')) {
                    this.moveWallElement(el, dx, dy);
                }
            });
            this.updateMinimap();
        },

        moveTableLikeElement(el, dx, dy) {
            const transform = el.getAttribute('transform');
            const translate = transform.match(/translate\(([^)]+)\)/)[1].split(',');
            let x = parseFloat(translate[0]) + dx;
            let y = parseFloat(translate[1]) + dy;
            
            x = this.constrainValue(x, 0, this.svg.clientWidth - el.getBBox().width);
            y = this.constrainValue(y, 0, this.svg.clientHeight - el.getBBox().height);
            
            const currentRotation = this.getCurrentRotation(el);
            el.setAttribute('transform', `translate(${x}, ${y}) rotate(${currentRotation})`);
        },

        moveWallElement(el, dx, dy) {
            let x1 = parseFloat(el.getAttribute('x1')) + dx;
            let y1 = parseFloat(el.getAttribute('y1')) + dy;
            let x2 = parseFloat(el.getAttribute('x2')) + dx;
            let y2 = parseFloat(el.getAttribute('y2')) + dy;
            
            x1 = this.constrainValue(x1, 0, this.svg.clientWidth);
            y1 = this.constrainValue(y1, 0, this.svg.clientHeight);
            x2 = this.constrainValue(x2, 0, this.svg.clientWidth);
            y2 = this.constrainValue(y2, 0, this.svg.clientHeight);
            
            el.setAttribute('x1', x1);
            el.setAttribute('y1', y1);
            el.setAttribute('x2', x2);
            el.setAttribute('y2', y2);
        },

        constrainValue(value, min, max) {
            return Math.max(min, Math.min(value, max));
        },
        deleteSelectedElements() {
            if (this.selectedElements.length > 0) {
                this.selectedElements.forEach(el => el.remove());
                this.selectedElements = [];
            } else if (this.selectedElement) {
                this.deleteSelectedElement();
            }
            this.updateMinimap();
        },
        getCurrentRotation(element) {
            const transform = element.getAttribute('transform');
            const rotateMatch = transform.match(/rotate\(([^)]+)\)/);
            return rotateMatch ? parseFloat(rotateMatch[1]) : 0;
        },
        rotateSelectedElement() {
            if (this.selectedElement) {
                if (this.selectedElement.classList.contains('table') || 
                    this.selectedElement.classList.contains('kitchen') || 
                    this.selectedElement.classList.contains('bar')) {
                    const currentRotation = this.getCurrentRotation(this.selectedElement);
                    const newRotation = (currentRotation + 45) % 360;
                    const transform = this.selectedElement.getAttribute('transform');
                    const translate = transform.match(/translate\(([^)]+)\)/)[1];
                    this.selectedElement.setAttribute('transform', `translate(${translate}) rotate(${newRotation})`);
                } else if (this.selectedElement.classList.contains('wall')) {
                    const x1 = parseFloat(this.selectedElement.getAttribute('x1'));
                    const y1 = parseFloat(this.selectedElement.getAttribute('y1'));
                    const x2 = parseFloat(this.selectedElement.getAttribute('x2'));
                    const y2 = parseFloat(this.selectedElement.getAttribute('y2'));
                    
                    const centerX = (x1 + x2) / 2;
                    const centerY = (y1 + y2) / 2;
                    
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    
                    const angle = Math.atan2(dy, dx);
                    const length = Math.sqrt(dx * dx + dy * dy);
                    
                    const newAngle = angle + Math.PI / 4;
                    
                    const newX1 = centerX - length / 2 * Math.cos(newAngle);
                    const newY1 = centerY - length / 2 * Math.sin(newAngle);
                    const newX2 = centerX + length / 2 * Math.cos(newAngle);
                    const newY2 = centerY + length / 2 * Math.sin(newAngle);
                    
                    this.selectedElement.setAttribute('x1', newX1);
                    this.selectedElement.setAttribute('y1', newY1);
                    this.selectedElement.setAttribute('x2', newX2);
                    this.selectedElement.setAttribute('y2', newY2);
                }
            }
            this.updateMinimap();
        },
        saveLayout() {
            const layout = {
                tables: [],
                walls: [],
                kitchens: [],
                bars: []
            };

            this.svg.querySelectorAll('.table').forEach(table => {
                layout.tables.push({
                    id: table.getAttribute('data-id'),
                    number: table.getAttribute('data-number'),
                    transform: table.getAttribute('transform')
                });
            });

            this.svg.querySelectorAll('.wall').forEach(wall => {
                layout.walls.push({
                    x1: wall.getAttribute('x1'),
                    y1: wall.getAttribute('y1'),
                    x2: wall.getAttribute('x2'),
                    y2: wall.getAttribute('y2')
                });
            });

            this.svg.querySelectorAll('.kitchen').forEach(kitchen => {
                layout.kitchens.push({
                    transform: kitchen.getAttribute('transform')
                });
            });

            this.svg.querySelectorAll('.bar').forEach(bar => {
                layout.bars.push({
                    transform: bar.getAttribute('transform')
                });
            });

            //localStorage.setItem('restaurantLayout', JSON.stringify(layout));
            saveBranchTableMap(layout).then(() => {
                this.$vs.notify({
                    title: 'Başarılı',
                    text: 'Düzen kaydedildi!',
                    color: 'success'
                });
            }).catch(error => {
                console.error('Error saving branch table map:', error);
                this.$vs.notify({
                    title: 'Hata',
                    text: 'Düzen kaydedilemedi!',
                    color: 'danger'
                });
            });
        },
        async loadLayout() {
            let savedLayout = null;
            try {
                const response = await getBranchTableMap();
                if (response && response.data && response.data.value) {
                    savedLayout = JSON.parse(response.data.value);
                } else {
                    console.error('Invalid response structure from getBranchTableMap');
                    savedLayout = null;
                }
                console.log(savedLayout);
            } catch (error) {
                console.error('Error loading branch table map:', error);
                // Handle the error appropriately
            }
            console.log(savedLayout);
           // const savedLayout = JSON.parse(localStorage.getItem('restaurantLayout'));
            if (savedLayout) {
                this.svg.innerHTML = '';
                this.tableCount = 0;
                this.wallCount = 0;
                this.kitchenCount = 0;
                this.barCount = 0;

                savedLayout.tables.forEach(tableData => {
                    const table = document.createElementNS("http://www.w3.org/2000/svg", "g");
                    table.setAttribute('class', 'table');
                    table.setAttribute('data-id', tableData.id);
                    table.setAttribute('data-number', tableData.number);
                    table.innerHTML = `
                        <!-- Masa -->
                        <rect x="0" y="0" width="60" height="40" rx="5" ry="5" fill="#8B4513" />
                        <rect x="2" y="2" width="56" height="36" rx="3" ry="3" fill="#D2691E" />
                        <rect x="4" y="4" width="52" height="32" rx="2" ry="2" fill="#A0522D" />
                        <rect x="6" y="6" width="48" height="28" fill="#CD853F" />
                        <line x1="6" y1="20" x2="54" y2="20" stroke="#8B4513" stroke-width="1" />
                        <line x1="30" y1="6" x2="30" y2="34" stroke="#8B4513" stroke-width="1" />
                        <!-- Koltuklar -->
                        <rect x="-10" y="10" width="20" height="20" rx="3" ry="3" fill="#8B4513" />
                        <rect x="50" y="10" width="20" height="20" rx="3" ry="3" fill="#8B4513" />
                        <rect x="20" y="-10" width="20" height="20" rx="3" ry="3" fill="#8B4513" />
                        <rect x="20" y="30" width="20" height="20" rx="3" ry="3" fill="#8B4513" />
                        <!-- Gölge ve etiket -->
                        <rect x="0" y="37" width="60" height="6" rx="2" ry="2" fill="#8B4513" opacity="0.6" />
                        <text x="30" y="20" text-anchor="middle" fill="white" font-size="14" font-weight="bold">Masa ${tableData.number}</text>
                    `;
                    table.setAttribute('transform', tableData.transform);
                    table.addEventListener('mousedown', this.startDragging);
                    table.addEventListener('click', this.selectElement);
                    this.svg.appendChild(table);
                    this.tableCount++;
                });

                savedLayout.bars.forEach(barData => {
                    const bar = document.createElementNS("http://www.w3.org/2000/svg", "g");
                    bar.setAttribute('class', 'bar');
                    bar.innerHTML = `
                        <!-- Bar Alanı -->
                        <rect x="0" y="0" width="120" height="40" rx="5" ry="5" fill="#8B4513" />
                        <rect x="2" y="2" width="116" height="36" rx="3" ry="3" fill="#D2691E" />
                        <!-- Bar Üstü -->
                        <rect x="5" y="5" width="110" height="30" fill="#CD853F" />
                        <!-- Bar Rafları -->
                        <rect x="10" y="10" width="100" height="5" fill="#A0522D" />
                        <rect x="10" y="20" width="100" height="5" fill="#A0522D" />
                        <!-- Bar Sandalyeleri -->
                        <circle cx="20" cy="45" r="5" fill="#8B4513" />
                        <circle cx="40" cy="45" r="5" fill="#8B4513" />
                        <circle cx="60" cy="45" r="5" fill="#8B4513" />
                        <circle cx="80" cy="45" r="5" fill="#8B4513" />
                        <circle cx="100" cy="45" r="5" fill="#8B4513" />
                        <!-- Etiket -->
                        <text x="60" y="55" text-anchor="middle" fill="white" font-size="10" font-weight="bold">Bar ${this.barCount + 1}</text>
                    `;
                    bar.setAttribute('transform', barData.transform);
                    bar.addEventListener('mousedown', this.startDragging);
                    bar.addEventListener('click', this.selectElement);
                    this.svg.appendChild(bar);
                    this.barCount++;
                });

                savedLayout.walls.forEach(wallData => {
                    const wall = document.createElementNS("http://www.w3.org/2000/svg", "line");
                    wall.setAttribute('class', 'wall');
                    wall.setAttribute('x1', wallData.x1);
                    wall.setAttribute('y1', wallData.y1);
                    wall.setAttribute('x2', wallData.x2);
                    wall.setAttribute('y2', wallData.y2);
                    wall.addEventListener('mousedown', this.startDragging);
                    wall.addEventListener('click', this.selectElement);
                    this.svg.appendChild(wall);
                    this.wallCount++;
                });

                savedLayout.kitchens.forEach(kitchenData => {
                    const kitchen = document.createElementNS("http://www.w3.org/2000/svg", "g");
                    kitchen.setAttribute('class', 'kitchen');
                    kitchen.innerHTML = `
                        <!-- Mutfak Alanı -->
                        <rect x="0" y="0" width="100" height="80" rx="5" ry="5" fill="#E0E0E0" stroke="#808080" stroke-width="2" />
                        <rect x="5" y="5" width="90" height="70" rx="3" ry="3" fill="#F0F0F0" stroke="#A9A9A9" stroke-width="1" />
                        <!-- Tezgah -->
                        <rect x="10" y="15" width="80" height="20" fill="#D3D3D3" stroke="#A9A9A9" stroke-width="1" />
                        <!-- Lavabo -->
                        <circle cx="25" cy="25" r="8" fill="#C0C0C0" stroke="#A9A9A9" stroke-width="1" />
                        <!-- Ocak -->
                        <rect x="60" y="20" width="25" height="10" fill="#696969" stroke="#A9A9A9" stroke-width="1" />
                        <!-- Etiket -->
                        <text x="50" y="75" text-anchor="middle" fill="black" font-size="10" font-weight="bold">Mutfak ${this.kitchenCount + 1}</text>
                    `;
                    kitchen.setAttribute('transform', kitchenData.transform);
                    kitchen.addEventListener('mousedown', this.startDragging);
                    kitchen.addEventListener('click', this.selectElement);
                    this.svg.appendChild(kitchen);
                    this.kitchenCount++;
                });

                this.tableCount = Math.max(...savedLayout.tables.map(t => parseInt(t.number)), 0);
            }
            this.updateMinimap();
        },
        toggleMinimap() {
      this.showMinimap = !this.showMinimap;
      if (this.showMinimap) {
        this.$nextTick(() => {
          this.initializeMinimap();
          this.updateMinimap();
        });
      }
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      if (this.isFullscreen) {
        if (this.editorContainer.requestFullscreen) {
          this.editorContainer.requestFullscreen();
        } else if (this.editorContainer.mozRequestFullScreen) { // Firefox
          this.editorContainer.mozRequestFullScreen();
        } else if (this.editorContainer.webkitRequestFullscreen) { // Chrome, Safari ve Opera
          this.editorContainer.webkitRequestFullscreen();
        } else if (this.editorContainer.msRequestFullscreen) { // Internet Explorer/Edge
          this.editorContainer.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari ve Opera
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // Internet Explorer/Edge
          document.msExitFullscreen();
        }
      }
      this.$nextTick(() => {
        this.updateMinimap();
        this.setSVGDimensions();
      });
    },
    setSVGDimensions() {
      const containerHeight = this.isFullscreen ? window.screen.height : window.innerHeight;
      const containerWidth = this.isFullscreen ? window.screen.width : window.innerWidth;
      this.svg.style.width = '2000px';
      this.svg.style.height = '2000px';
      this.editorContainer.style.height = `${containerHeight}px`;
      this.editorContainer.style.width = `${containerWidth}px`;
    },
    handleFullscreenChange() {
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      this.$nextTick(() => {
        this.updateMinimap();
        this.setSVGDimensions();
      });
    },
    }
}
</script>

<style>
 body, html {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
        #editor-container {
            width: 100%;
            height: 100%;
            overflow: auto;
        }
        #editor-container:fullscreen {
  background-color: white;
  width: 100vw;
  height: 100vh;
}
        #editor {
            width: 2000px;
            height: 2000px;
            border: 1px solid #ccc;
        }
        .table, .wall, .kitchen, .bar {
            cursor: move;
        }
        .wall {
            stroke: #8B4513;
            stroke-width: 10;
            stroke-linecap: square;
        }
        .selected {
            stroke: red;
            stroke-width: 2;
        }
        .wall.selected {
            stroke-width: 12;
        }
        .selection-area {
            fill: rgba(0, 0, 255, 0.1);
            stroke: blue;
            stroke-width: 1;
        }
        #minimap {
            position: fixed;
            bottom: 10px;
            right: 10px;
            width: 200px;
            height: 200px;
            border: 2px solid #000;
            background-color: rgba(255, 255, 255, 0.8);
            cursor: move;
        }
        #minimap-viewport {
            position: absolute;
            border: 2px solid red;
            background-color: rgba(255, 0, 0, 0.2);
        }
        text {
            user-select: none;
        }
        #minimap-toggle {
  position: fixed;
  bottom: 220px;
  right: 10px;
  width: 40px;
  height: 40px;
  background-color: white;
  border: 2px solid #000;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
}

#minimap-toggle i {
  font-size: 20px;
  color: #000;
}

#minimap {
  transition: opacity 0.3s ease-in-out;
}
.minimap {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 200px;
  height: 200px;
  border: 2px solid #000;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: move;
  transition: opacity 0.3s ease-in-out;
}

.minimap.hidden {
  opacity: 0;
  pointer-events: none;
}
</style>